export const mockUser = {
  displayName: 'Clif',
  profileId: 'BC-7K4X-M92P',
  otp: '482917',
  otpExpiresIn: '9:42',
  topicsCompleted: 5,
  topicsTotal: 7,
};

export const topicCategories = [
  { id:'basics', name:'The Basics', icon:'Heart', color:'#f43f5e',
    desc:'Relationship type, preferences, location',
    questions:[
      {id:'b1',text:'What type of relationship are you looking for?',ph:'Casual, serious, open to anything...'},
      {id:'b2',text:'What age range are you comfortable with?',ph:'e.g. 25-35'},
      {id:'b3',text:'How flexible are you on location?',ph:'Local only, willing to travel...'},
    ],
    answers:{b1:'Open to serious but not forcing it',b2:'28-38',b3:'Within an hour drive'},
    completed:true },
  { id:'lifestyle', name:'Lifestyle', icon:'Coffee', color:'#f59e0b',
    desc:'Habits, substances, routines',
    questions:[
      {id:'l1',text:'How do you feel about drinking?',ph:'Social, daily, never...'},
      {id:'l2',text:'Cannabis use?',ph:'Daily, occasional, never...'},
      {id:'l3',text:'How important is fitness?',ph:'Very, somewhat, not really...'},
      {id:'l4',text:'Describe your ideal weekend',ph:'Adventure, relaxation, social...'},
    ],
    answers:{l1:'Social drinker',l2:'Regular user, not ashamed of it',l3:'Important but not obsessive',l4:'Hiking with the dog, then cooking together'},
    completed:true },
  { id:'values', name:'Values & Politics', icon:'Scale', color:'#3b82f6',
    desc:'Political views, religion, social issues',
    questions:[
      {id:'v1',text:'How would you describe your political stance?',ph:'Progressive, moderate, conservative...'},
      {id:'v2',text:'Role of religion in your life?',ph:'Central, cultural, none...'},
      {id:'v3',text:'What social issue matters most to you?',ph:'Climate, equality, education...'},
    ],
    answers:{v1:'Progressive but avoid arguments',v2:'Spiritual not religious',v3:'Mental health access'},
    completed:true },
  { id:'intimacy', name:'Intimacy', icon:'Flame', color:'#f97316',
    desc:'Boundaries, preferences, importance',
    questions:[
      {id:'i1',text:'How important is physical intimacy?',ph:'Essential, important, not a priority...'},
      {id:'i2',text:'Boundaries or hard limits to communicate?',ph:'Be as specific or general as you want...'},
      {id:'i3',text:'How do you feel about discussing this early?',ph:'Prefer upfront, wait for comfort...'},
    ],
    answers:{i1:'Very important',i2:'Open-minded within reason',i3:'Better to know early'},
    completed:true },
  { id:'dealbreakers', name:'Dealbreakers', icon:'ShieldAlert', color:'#ef4444',
    desc:'Hard nos, must-haves, non-negotiables',
    questions:[
      {id:'d1',text:'Name your top 3 dealbreakers',ph:'Things you absolutely cannot work with...'},
      {id:'d2',text:'What are your must-haves?',ph:'Things you need in a partner...'},
    ],
    answers:{d1:'Dishonesty, lack of ambition, cruelty to animals',d2:'Humor, independence, dog-friendly'},
    completed:true },
  { id:'communication', name:'Communication', icon:'MessageCircle', color:'#14b8a6',
    desc:'Conflict style, love languages, attachment',
    questions:[
      {id:'c1',text:'How do you handle conflict?',ph:'Direct, avoidant, need space first...'},
      {id:'c2',text:"What's your love language?",ph:'Words, touch, acts of service...'},
      {id:'c3',text:'Describe your attachment style',ph:'Secure, anxious, avoidant...'},
    ],
    answers:{},
    completed:false },
  { id:'future', name:'Future Plans', icon:'Compass', color:'#a855f7',
    desc:'Kids, marriage, career priorities',
    questions:[
      {id:'f1',text:'Do you want kids?',ph:'Yes, no, maybe, already have them...'},
      {id:'f2',text:'How do you feel about marriage?',ph:'Want it, open to it, not interested...'},
      {id:'f3',text:'Ideal 5-year plan?',ph:'Career, travel, settling down...'},
    ],
    answers:{},
    completed:false },
];

export const mockPartners = [
  { id:'par_01', displayName:'Alex', initial:'A', profileId:'BC-9R2T-L45N',
    linkedAt:'2 days ago', status:'active',
    youShare:['basics','lifestyle','intimacy'],
    theyShare:['basics','lifestyle','intimacy','values'],
    mutualTopics:['basics','lifestyle','intimacy'],
    compatibility:{
      basics:   {score:0.87, signal:'strong',  summary:"You're looking for similar things"},
      lifestyle:{score:0.72, signal:'good',    summary:'Mostly aligned, a few differences worth exploring'},
      intimacy: {score:0.91, signal:'strong',  summary:'Strong chemistry signals'},
    },
    sigprints:{
      basics:   {yours:'RTBSLOSHFCHDCT8UQQ07',theirs:'RTBSLOSHFCHDDT8VPR12'},
      lifestyle:{yours:'NSLFLOMDFCHDDF8GNMYG',theirs:'NSLFLOSHFCHDDF8HNPZH'},
      intimacy: {yours:'RTISLOSHFCHDCT8RRYU5',theirs:'RTISLOSHFCHDCT8SSZU6'},
    },
  },
  { id:'par_02', displayName:'Sam', initial:'S', profileId:'BC-3F8W-Q71J',
    linkedAt:'5 min ago', status:'pending',
    youShare:[], theyShare:[], mutualTopics:[],
    compatibility:{}, sigprints:{},
  },
];

export const signalConfig = {
  strong:  { color:'#10b981', bg:'bg-emerald-500', text:'text-emerald-400', label:'Strong Match' },
  good:    { color:'#f59e0b', bg:'bg-amber-500',   text:'text-amber-400',  label:'Good Alignment' },
  explore: { color:'#f97316', bg:'bg-orange-500',   text:'text-orange-400', label:'Worth Exploring' },
  tension: { color:'#f87171', bg:'bg-red-400',      text:'text-red-400',    label:'Needs Conversation' },
};
